module.exports = __webpack_public_path__ + "src/assets/img/package_header.d8f307ab.jpg";